import { CONTEXT_NAMES } from '@adsk/alloy-helpers';
import { getOrCreateGlobalStore } from '@adsk/alloy-react-context';

export type CustomHelpLinkStore = {
  link?: string;
  setLink: (link?: string) => void;
};

export const useCustomHelpLinkStore = () =>
  getOrCreateGlobalStore<CustomHelpLinkStore>(
    (set, get) => ({
      link: undefined,
      setLink: (newLink) => {
        if (newLink !== get().link) {
          set({ link: newLink });
        }
      },
    }),
    CONTEXT_NAMES.CustomHelpContext,
  )();
